// extracted by mini-css-extract-plugin
export default {"base":"SearchInput_base__Fv2Zm","left-icon":"SearchInput_left-icon__ULqyK","input":"SearchInput_input__W0ocp"};